import { OAUTH_TOKEN } from "./types";
import base64url from "base64-url";
import createHash from "create-hash/browser";
import qs from "querystring";
import cryptoRandomHex from "crypto-random-hex";

const generateCodeChallenge = (verifier) => {
    const hash = createHash("sha256");
    hash.update(verifier);
    return base64url.encode(hash.digest());
};

const getScopes = () => [
    "openid",
    "sc.gcics.vendors",
    "sc.gcics.vendors:write",
    "sc.gcics.vendors:read",
    "sc.gcics.yard:read",
    "sc.gcics.item:write",
    "sc.gcics.item:read",
    "sc.gcics.security:read",
    "sc.gcics.advance-shipping",
    "sc.gcics.advance-shipping:read",
    "sc.gcics.advance-shipping:write",
    "sc.gcics.forecast:write",
    "sc.gcics.forecast:read",
    "sc.gcics.global-data:write",
    "sc.gcics.global-data:read",
    "sc.gcics.moq:read",
    "sc.gcics.moq:write",
];

export const getAuthUrl = () => async (dispatch) => {
    try {
        const verifier = base64url.encode(cryptoRandomHex(16));
        const challenge = generateCodeChallenge(verifier);

        localStorage.setItem("verifier", verifier);
        localStorage.setItem("challenge", challenge);

        const scopeParam = getScopes().join(" ");
        const loginURL =
            `${window.env.OAUTH_URL}?scope=${scopeParam}&response_type=code&client_id=${window.env.OAUTHCLIENTID}` +
            `&redirect_uri=${window.env.REDIRECT_URI}&code_challenge=${challenge}&code_challenge_method=S256`;

        dispatch({ type: OAUTH_TOKEN, payload: loginURL });
    } catch (error) {
        console.error("Error generating auth URL:", error);
    }
};
